import React, { useRef, useEffect, useCallback } from 'react';
import './RichTextEditor.css';

/**
 * Paprastas teksto redaktorius su formatavimo juosta (bold, italic, sąrašai, nuoroda).
 * Reikšmė – HTML eilutė; saugant galima išvalyti pavojingus tagus.
 */
function RichTextEditor({ value = '', onChange, placeholder = '', rows = 5, minHeight, className = '' }) {
  const editorRef = useRef(null);
  const isInternalChange = useRef(false);

  useEffect(() => {
    const el = editorRef.current;
    if (!el) return;
    const html = value == null ? '' : String(value);
    if (el.innerHTML !== html && !isInternalChange.current) {
      el.innerHTML = html;
    }
  }, [value]);

  const handleInput = useCallback(() => {
    const el = editorRef.current;
    if (!el) return;
    isInternalChange.current = true;
    const html = el.innerHTML;
    onChange(html);
    isInternalChange.current = false;
  }, [onChange]);

  const exec = useCallback((cmd, valueOrUndefined) => {
    document.execCommand(cmd, false, valueOrUndefined);
    editorRef.current?.focus();
    handleInput();
  }, [handleInput]);

  const addLink = useCallback(() => {
    const url = window.prompt('Įveskite URL:', 'https://');
    if (url != null && url !== '') exec('createLink', url);
  }, [exec]);

  const style = minHeight != null ? { minHeight: typeof minHeight === 'number' ? `${minHeight}px` : minHeight } : undefined;

  return (
    <div className={`rich-text-editor ${className}`}>
      <div className="rich-text-editor-toolbar">
        <button type="button" className="rte-btn" onClick={() => exec('bold')} title="Paryškinti">
          <b>B</b>
        </button>
        <button type="button" className="rte-btn" onClick={() => exec('italic')} title="Kursyvas">
          <i>I</i>
        </button>
        <button type="button" className="rte-btn" onClick={() => exec('underline')} title="Pabraukti">
          <u>U</u>
        </button>
        <span className="rte-sep" />
        <button type="button" className="rte-btn" onClick={addLink} title="Nuoroda">
          🔗
        </button>
        <span className="rte-sep" />
        <button type="button" className="rte-btn" onClick={() => exec('insertUnorderedList')} title="Ženkluotas sąrašas">
          • Sąrašas
        </button>
        <button type="button" className="rte-btn" onClick={() => exec('insertOrderedList')} title="Numeruotas sąrašas">
          1. Sąrašas
        </button>
      </div>
      <div
        ref={editorRef}
        className="rich-text-editor-body"
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-placeholder={placeholder}
        style={style}
      />
    </div>
  );
}

export default RichTextEditor;
